/**
 * @module mapbs.components.bsprinting.bsprintingservice
 */
import angular from 'angular';

const moduleBsprinting = angular.module('mapbsBsprintingModule', []);

class PrintingService {
    /**
   * @constructor
   * @private
   * @param {angular.$injector} $injector Main injector.
   * @param {angular.$http} $http
   * @param {angular.$timeout} $timeout Angular timeout service.
   * @param {angular.$q} $q
   * @ngInject
   */
    constructor($injector, $http, $timeout, $q) {
    /** @type {string} @private */
        this.printBaseUrl = $injector.get('baseUrl');
        /** @type {angular.$http} @private */
        this.http = $http;
        /** @type {angular.$timeout} @private */
        this.timeout = $timeout;
        /** @type {angular.$q} @private */
        this.q = $q;

        /** @type {?angular.$q.Deferred} @private */
        this.requestCanceler_ = null;
        /** @private */
        this.statusTimeoutPromise_ = null;

        /** @type {?angular.$q.Deferred} @private */
        this.reportpromise;

        /** @type {Array<MapFishPrintReportResponse>} @private */
        this.multiPrints = [];
    }

    /**
   * creates a multiprint
   * @param {string} layout - the layoutname (from vars_mapbs)
   * @param {string} param1 - the first param, can contain multiple params (commaseperated)
   * @param {string?} param2 - second param, may be null
   */
    createMultiReport(layout, param1, param2 = null) {
        this.reportpromise = this.q.defer();

        const httpconfig = /** @type {angular.$http.Config} */ ({
            headers: {'Content-Type': 'text/xml; charset=UTF-8'},
        });

        const spec = {};

        this.http
      .post(
          `${this.printBaseUrl}multireport/${layout}/${param1}/${param2}`,
          spec,
          httpconfig
      )
      .then((response) => {
          this.multiPrints = response.data;
          this.getMultiPrintStatus();
      });

        return this.reportpromise.promise;
    }

    /**
   * get overall state of a Multiprint
   */
    getMultiPrintStatus() {
        if (!this.multiPrints) {
            return;
        }

        const httpconfig = /** @type {angular.$http.Config} */ ({});

        const refString = this.multiPrints['statusUrl'];

        this.http.get(`${this.printBaseUrl}${refString}`, httpconfig)
            .then(
                this.handleMultiStatusSuccess.bind(this),
                this.handleMultiStatusError.bind(this)
            );
    }

    /**
   * handles the answer for multi print state
   */
    handleMultiStatusSuccess(resp) {
        const refString = this.multiPrints['downloadUrl'];
        const downloadurl = `${this.printBaseUrl}${refString}`;
        if (resp.data['alldone']) {
            for (const print in resp.data.prints) {
                if (print.status === 'error') {
                    this.reportpromise.reject(print.error);
                    return;
                }
            }
            this.reportpromise.resolve(downloadurl);
        } else {
            this.statusTimeoutPromise_ = this.timeout(
                () => {
                    this.getMultiPrintStatus();
                },
                1000,
                false
            );
        }
    }

    /**
   * handles if the request for state of multiprint fails
   */
    handleMultiStatusError(resp) {
    // eslint-disable-line no-unused-vars
        const errormessage = 'Fehler beim Erstellen des Dokumentes';
        this.reportpromise.reject(errormessage);
    }
}

moduleBsprinting.service('mapbsBsprintingService', PrintingService);

export default moduleBsprinting;
